var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var toolkit = require('@reduxjs/toolkit');

var axios = _interopDefault(require('axios'));

var effects = require('redux-saga/effects');

var React = require('react');

var React__default = _interopDefault(React);

var styled = require('styled-components');

var styled__default = _interopDefault(styled);

var OutsideClickHandler = _interopDefault(require('react-outside-click-handler'));

var TimeAgo = _interopDefault(require('javascript-time-ago'));

var enTimeAgo = _interopDefault(require('javascript-time-ago/locale/en'));

var arTimeAgo = _interopDefault(require('javascript-time-ago/locale/ar'));

var io = require('react-icons/io');

var reactI18next = require('react-i18next');

var reactRedux = require('react-redux');

var messaging = require('firebase/messaging');

var ReactTimeAgo = _interopDefault(require('react-time-ago'));

var reactRouterDom = require('react-router-dom');

var bi = require('react-icons/bi');

var fi = require('react-icons/fi');

var fc = require('react-icons/fc');

var app = require('firebase/app');

var FingerprintJS = _interopDefault(require('@fingerprintjs/fingerprintjs'));

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var defaultTheme = {
  breakpoints: {
    xxs: "360px",
    xs: "480px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
    xxl: "1600px"
  },
  notificationColors: {
    date: "#505050",
    icon: "#000",
    iconHover: "#ff9100",
    scrollBarThumb: "#505050",
    scrollBarTrack: "#f5f5f5",
    unreadNotification: "#40a9ff",
    background: "#fff"
  },
  notificationLayout: {
    dropDownAnimation: "opacity",
    displayImages: true,
    iconSize: 3,
    dropDownHeight: 90,
    itemTheme: "defaultComponents"
  }
};

var notificationConfigs = function notificationConfigs() {
  var configs = {};
  var isInitialized;

  var initialize = function initialize(customConfigs) {
    if (isInitialized) return;
    var theme = customConfigs.theme;

    var combinedTheme = _extends({}, defaultTheme, theme);

    configs = _extends({
      notificationsEndPoint: "/notifications",
      readsEndPoint: "/reads",
      firebaseTokensEndPoint: "/user_tokens",
      theme: combinedTheme,
      enableFirebase: true,
      enableMapSelectors: false
    }, customConfigs);
    isInitialized = true;
  };

  var getConfigs = function getConfigs() {
    return configs;
  };

  return {
    initialize: initialize,
    getConfigs: getConfigs
  };
};

var configs = notificationConfigs();

var safeJSONParse = function safeJSONParse(dataObject) {
  try {
    var parsedObject = JSON.parse(dataObject);
    return parsedObject;
  } catch (error) {
    return null;
  }
};

var loadFromLocalStorage = function loadFromLocalStorage(key) {
  var item = localStorage.getItem(key);
  return safeJSONParse(item);
};

var apiRequest = function apiRequest(customConfigs) {
  if (customConfigs === void 0) {
    customConfigs = {};
  }

  var config = configs.getConfigs();

  var headers = _extends({}, config.authHeaders && loadFromLocalStorage(config.authHeaders));

  return axios(_extends({
    baseURL: config.baseURL,
    headers: headers
  }, customConfigs));
};

var constructIndexPayload = function constructIndexPayload(actionPayload) {
  var _storedEntity$meta;

  var _ref = actionPayload || {},
      page = _ref.page,
      perPage = _ref.perPage,
      storedEntity = _ref.storedEntity,
      locale = _ref.locale;

  var params = {
    page: page || ((_storedEntity$meta = storedEntity.meta) === null || _storedEntity$meta === void 0 ? void 0 : _storedEntity$meta.current_page),
    per_page: perPage || 10,
    locale: locale || "en"
  };
  var payload = {
    params: params,
    url: configs.getConfigs().notificationsEndPoint
  };
  return payload;
};

var constructMarkAsReadPayload = function constructMarkAsReadPayload(actionPayload) {
  return {
    data: {
      reads: _extends({}, !actionPayload.markAllAsRead && {
        reference_uuids: actionPayload.notificationsIds
      }, {
        is_read: true
      })
    },
    method: "put",
    url: configs.getConfigs().readsEndPoint
  };
};

var constructFirebaseTokenPayload = function constructFirebaseTokenPayload(actionPayload, method) {
  return _extends({
    data: {
      user_token: _extends({}, actionPayload)
    },
    method: method,
    url: method === "post" ? configs.getConfigs().firebaseTokensEndPoint : configs.getConfigs().firebaseTokensEndPoint + "/" + actionPayload.device_id
  }, actionPayload.headers && {
    headers: actionPayload.headers
  });
};

var indexNotifications = toolkit.createAsyncThunk("notifications/index", function (payload) {
  try {
    return Promise.resolve(apiRequest(constructIndexPayload(payload))).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
});
var markAsRead = toolkit.createAsyncThunk("notifications/markAsRead", function (payload) {
  try {
    return Promise.resolve(apiRequest(constructMarkAsReadPayload(payload))).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
});
var resetNotificationsByLocale = toolkit.createAsyncThunk("notifications/resetNotificationsByLocale", function (payload) {
  try {
    return Promise.resolve(apiRequest(constructIndexPayload(payload))).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
});
var setFirebaseToken = toolkit.createAsyncThunk("firebaseTokens/setFirebaseToken", function (payload) {
  try {
    return Promise.resolve(apiRequest(constructFirebaseTokenPayload(payload, "post"))).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
});
var deleteFirebaseToken = toolkit.createAsyncThunk("firebaseTokens/deleteFirebaseToken", function (payload) {
  try {
    return Promise.resolve(apiRequest(constructFirebaseTokenPayload(payload, "delete"))).then(function (response) {
      return response.data;
    });
  } catch (e) {
    return Promise.reject(e);
  }
});
var notificationsAdapter = toolkit.createEntityAdapter({
  selectId: function selectId(notification) {
    return notification.reference_uuid;
  },
  sortComparer: function sortComparer(a, b) {
    return new Date(b.created_at) - new Date(a.created_at);
  }
});
var initialState = notificationsAdapter.getInitialState({
  currentData: [],
  meta: {},
  loading: false
});

var indexRequest = function indexRequest(state) {
  state.loading = true;
};

var indexSuccess = function indexSuccess(state, action) {
  var _action$payload = action.payload,
      notifications = _action$payload.notifications,
      meta = _action$payload.meta;
  state.currentData = notifications;
  state.loading = false;
  state.meta = meta;
  state.errors = {};
  notificationsAdapter.addMany(state, notifications);
};

var indexFailure = function indexFailure(state, action) {
  state.loading = false;
  state.errors = action.payload;
};

var markAsReadRequest = function markAsReadRequest(state, action) {
  updateReadState(action.payload, state);
};

var updateReadState = function updateReadState(_ref, state) {
  var notificationsIds = _ref.notificationsIds;
  notificationsIds.forEach(function (id) {
    return state.entities[id].is_read = true;
  });
};

var markAsReadRequestThunk = function markAsReadRequestThunk(state, action) {
  updateReadState(action.meta.arg, state);
};

var resetByLocale = function resetByLocale() {
  return initialState;
};

var notificationsSlice = toolkit.createSlice({
  name: "notifications",
  initialState: initialState,
  reducers: {
    indexRequest: indexRequest,
    indexSuccess: indexSuccess,
    indexFailure: indexFailure,
    markAsReadRequest: markAsReadRequest,
    resetByLocale: resetByLocale,
    addOne: notificationsAdapter.addOne,
    reset: function reset() {
      return initialState;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(indexNotifications.fulfilled, indexSuccess);
    builder.addCase(indexNotifications.pending, indexRequest);
    builder.addCase(indexNotifications.rejected, indexFailure);
    builder.addCase(markAsRead.pending, markAsReadRequestThunk);
    builder.addCase(markAsRead.fulfilled, function () {});
    builder.addCase(resetNotificationsByLocale.pending, resetByLocale);
    builder.addCase(resetNotificationsByLocale.fulfilled, indexSuccess);
    builder.addCase(resetNotificationsByLocale.rejected, indexFailure);
  }
});

var notificationsSelector = function notificationsSelector(enableMapSelectors) {
  return function (state) {
    return enableMapSelectors ? state.get("notifications") : state.notifications;
  };
};

var notificationsGeneralSelectors = function notificationsGeneralSelectors(enableMapSelectors) {
  return notificationsAdapter.getSelectors(notificationsSelector(enableMapSelectors));
};

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(getNotificationsSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(markAsReadSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(setFirebaseTokenSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(deleteFirebaseTokenSaga),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(watchGetNotifications),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(watchMarkAsRead),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(watchReset),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(watchSetFirebaseToken),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(watchDeleteFirebaseToken);

function getNotificationsSaga(action) {
  var actions, response;
  return _regeneratorRuntime.wrap(function getNotificationsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          actions = notificationsSlice.actions;
          _context.prev = 1;
          _context.next = 4;
          return effects.call(apiRequest, constructIndexPayload(action.payload));

        case 4:
          response = _context.sent;
          _context.next = 7;
          return effects.put(actions.indexSuccess(response.data));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          _context.next = 13;
          return effects.put(actions.indexFailure(_context.t0.response.data));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 9]]);
}

function markAsReadSaga(action) {
  return _regeneratorRuntime.wrap(function markAsReadSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return effects.call(apiRequest, constructMarkAsReadPayload(action.payload));

        case 3:
          _context2.next = 7;
          break;

        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2["catch"](0);

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 5]]);
}

function setFirebaseTokenSaga(action) {
  return _regeneratorRuntime.wrap(function setFirebaseTokenSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return effects.call(apiRequest, constructFirebaseTokenPayload(action.payload, "post"));

        case 3:
          _context3.next = 7;
          break;

        case 5:
          _context3.prev = 5;
          _context3.t0 = _context3["catch"](0);

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 5]]);
}

function deleteFirebaseTokenSaga(action) {
  return _regeneratorRuntime.wrap(function deleteFirebaseTokenSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return effects.call(apiRequest, constructFirebaseTokenPayload(action.payload, "delete"));

        case 3:
          _context4.next = 7;
          break;

        case 5:
          _context4.prev = 5;
          _context4.t0 = _context4["catch"](0);

        case 7:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 5]]);
}

function watchGetNotifications() {
  return _regeneratorRuntime.wrap(function watchGetNotifications$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return effects.takeEvery(notificationsSlice.actions.indexRequest, getNotificationsSaga);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function watchMarkAsRead() {
  return _regeneratorRuntime.wrap(function watchMarkAsRead$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return effects.takeEvery(notificationsSlice.actions.markAsReadRequest, markAsReadSaga);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function watchReset() {
  return _regeneratorRuntime.wrap(function watchReset$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return effects.takeEvery(notificationsSlice.actions.resetByLocale, getNotificationsSaga);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function watchSetFirebaseToken() {
  return _regeneratorRuntime.wrap(function watchSetFirebaseToken$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return effects.takeLatest(firebaseTokensSlice.actions.setTokenRequest, setFirebaseTokenSaga);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function watchDeleteFirebaseToken() {
  return _regeneratorRuntime.wrap(function watchDeleteFirebaseToken$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return effects.takeLatest(firebaseTokensSlice.actions.deleteTokenRequest, deleteFirebaseTokenSaga);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

var sagas = [watchGetNotifications, watchMarkAsRead, watchReset, watchSetFirebaseToken, watchDeleteFirebaseToken];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var growDownIn = styled.keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n0% {\n  display:block;\n  transform: scaleY(0)\n}\n80% {\n  transform: scaleY(1.05)\n}\n100% {\n  transform: scaleY(1)\n}\n"])));
var growDownOut = styled.keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n0% {\n  transform: scaleY(1)\n}\n80% {\n  transform: scaleY(1.05)\n}\n100% {\n  display:none;\n  transform: scaleY(0)\n}\n"])));
var opacityIn = styled.keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n0% {\n  visibility:visible;\n  opacity:0;\n}\n50% {\n  opacity: 0.6;\n}\n\n100% {\n opacity:1;\n \n}\n"])));
var opacityOut = styled.keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n0% {\n  opacity:1;\n}\n50% {\n  opacity: 0.6;\n}\n\n100% {\nvisibility:hidden;\n opacity:0;\n\n}\n"])));
var opacityOutWithDisplayNone = styled.keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n0% {\n  opacity:1;\n}\n50% {\n  opacity: 0.6;\n}\n\n100% {\ndisplay:none;\nopacity:0;\n\n}\n\n\n"])));
var animations = {
  __proto__: null,
  growDownIn: growDownIn,
  growDownOut: growDownOut,
  opacityIn: opacityIn,
  opacityOut: opacityOut,
  opacityOutWithDisplayNone: opacityOutWithDisplayNone
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

var getDropDownAnimation = function getDropDownAnimation(props) {
  if (!props.isInitiallyClicked) return "none";
  var baseAnimation = "" + props.theme.notificationLayout.dropDownAnimation;
  var animationClass = props.isDropDownVisible ? baseAnimation + "In" : baseAnimation + "Out";
  return animations[animationClass];
};

var calculateRelativeToIconSize = function calculateRelativeToIconSize(props, value) {
  return props.theme.notificationLayout.iconSize * value / 3;
};

var NotificationCenterContainer = styled__default.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  line-height: 28px;\n  svg {\n    color: ", ";\n    font-size: ", "em;\n    cursor: pointer;\n  }\n\n  svg:hover {\n    color: ", ";\n    transition: all 0.3s ease;\n  }\n\n  @media (max-width: ", ") {\n    position: static;\n  }\n  a:hover {\n    color: black;\n  }\n  a {\n    color: black;\n  }\n"])), function (props) {
  var _props$theme$notifica;

  return (_props$theme$notifica = props.theme.notificationColors) === null || _props$theme$notifica === void 0 ? void 0 : _props$theme$notifica.icon;
}, function (props) {
  return props.theme.notificationLayout.iconSize;
}, function (props) {
  var _props$theme$notifica2, _props$theme$notifica3;

  return ((_props$theme$notifica2 = props.theme.notificationColors) === null || _props$theme$notifica2 === void 0 ? void 0 : _props$theme$notifica2.iconHover) || ((_props$theme$notifica3 = props.theme.notificationColors) === null || _props$theme$notifica3 === void 0 ? void 0 : _props$theme$notifica3.icon);
}, function (props) {
  return props.theme.breakpoints.sm || props.theme.breakpoints.$sm;
});
var DropDownContainer = styled__default.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: ", "%;\n  ", "\n  margin: 0px 10px;\n  width: 27em;\n  padding: 1em;\n  ", "\n  border-radius: 4px;\n  overflow: auto;\n  z-index: 5;\n  background: ", ";\n  animation: ", " 300ms ease-in-out forwards;\n  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;\n\n  ", "\n  min-height: 30vh;\n  @media (max-width: ", ") {\n    max-height: calc(100vh - ", "px);\n    min-height: fit-content;\n    bottom: 0;\n    top: ", "px;\n    width: 90%;\n    ", "\n    margin: 0px 0px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: ", ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background-color: ", ";\n  }\n  // fire-fox support\n  scrollbar-color: ", "\n    ", ";\n  scrollbar-width: thin;\n"])), function (props) {
  return props.theme.notificationLayout.top || 100;
}, function (props) {
  return props.align + ":" + (props.theme.notificationLayout.alignment || 0) + "px;";
}, function (props) {
  return !props.isInitiallyClicked && "visibility:hidden;";
}, function (props) {
  return props.theme.notificationColors.background;
}, function (props) {
  return getDropDownAnimation(props);
}, function (props) {
  return props.noDataFound ? "height: " + (props.theme.notificationLayout.dropDownHeight || 30) + "vh;" : "max-height:" + (props.theme.notificationLayout.dropDownHeight || 90) + "vh;";
}, function (props) {
  return props.theme.breakpoints.sm || props.theme.breakpoints.$sm;
}, function (props) {
  return calculateRelativeToIconSize(props, 60);
}, function (props) {
  return props.theme.notificationLayout.headerHeight || calculateRelativeToIconSize(props, 50);
}, function (props) {
  return props.align + ":5%;";
}, function (props) {
  return props.theme.notificationColors.scrollBarTrack;
}, function (props) {
  return props.theme.notificationColors.scrollBarThumb;
}, function (props) {
  return props.theme.notificationColors.scrollBarThumb;
}, function (props) {
  return props.theme.notificationColors.scrollBarTrack;
});
var Image = styled__default.img(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n  width: 5em;\n  height: calc(5em - 15px);\n  border-radius: 50%;\n"])));
var Meta = styled__default.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  width: 100%;\n  margin-top: 10px;\n"])));
var NotificationIcon = styled__default.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  font-size: 1.3em;\n  display: flex;\n  align-items: center;\n  &:after {\n    ", "\n    animation: ", " 300ms ease-in-out forwards;\n  }\n"])), function (props) {
  return props.theme.notificationLayout.showArrow && "\n    content: \" \";\n    position: absolute;\n    right: 1.25px;\n    top: 35px;\n    z-index: 4;\n    width: 0;\n    height: 0;\n    border-top: none;\n    border-right: 15px solid transparent;\n    border-left: 15px solid transparent;\n    border-bottom: 15px solid " + props.theme.notificationColors.background + ";\n    \n    " + (!props.isInitiallyClicked ? "visibility:hidden;" : "") + "\n  ";
}, function (props) {
  return getDropDownAnimation(props);
});
var UnreadCount = styled__default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  width: ", "em;\n  height: ", "em;\n  border-radius: 50%;\n  position: absolute;\n  background-color: red;\n  top: 10%;\n  right: 5px;\n  display: ", ";\n  animation: ", " 300ms ease-in-out forwards;\n  div {\n    color: white;\n    font-size: ", "em;\n    text-align: center;\n    line-height: 1.4;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"])), function (props) {
  return calculateRelativeToIconSize(props, 1.2);
}, function (props) {
  return calculateRelativeToIconSize(props, 1.2);
}, function (props) {
  return props.isVisible ? "block" : "none";
}, opacityIn, function (props) {
  return calculateRelativeToIconSize(props, 0.8);
});
var ForceScroll = styled__default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  min-height: 10vh;\n"])));
var NotificationTitleContainer = styled__default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n"])));
var NotificationSettings = styled__default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  svg {\n    font-size: 2em;\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.theme.notificationColors.markAsRead || props.theme.notificationColors.icon;
}, function (props) {
  return props.theme.notificationColors.markAsReadHover || props.theme.notificationColors.iconHover;
});
var SettingsDropDownContainer = styled__default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  animation: ", " 200ms ease-in-out forwards;\n  z-index: 6;\n  background: ", ";\n  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  padding: 1em;\n  ", "\n  @media (max-width: ", ") {\n    height: 120px;\n  }\n"])), function (props) {
  return getDropDownAnimation(props);
}, function (props) {
  return props.theme.notificationColors.background;
}, function (props) {
  return !props.isInitiallyClicked && "visibility:hidden;";
}, function (props) {
  return props.theme.breakpoints.xxs || props.theme.breakpoints.$xxs;
});
var CheckMarkContainer = styled__default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  margin: 0px 5px;\n"])));
var MarkAllAsRead = styled__default.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  &:hover {\n    color: #1890ff;\n  }\n"])));

var setTokenRequest = function setTokenRequest(state, action) {
  var token = action.payload.token;
  state.currentToken = token;
};

var deleteTokenRequest = function deleteTokenRequest(state) {
  state.currentToken = null;
};

var setTokenRequestThunk = function setTokenRequestThunk(state, action) {
  setTokenRequest(state, {
    payload: action.meta.arg
  });
};

var firebaseTokensSlice = toolkit.createSlice({
  name: "firebaseTokens",
  initialState: {
    currentToken: null
  },
  reducers: {
    setTokenRequest: setTokenRequest,
    deleteTokenRequest: deleteTokenRequest
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(setFirebaseToken.pending, setTokenRequestThunk);
    builder.addCase(setFirebaseToken.fulfilled, function () {});
    builder.addCase(deleteFirebaseToken.pending, deleteTokenRequest);
    builder.addCase(deleteFirebaseToken.fulfilled, function () {});
  }
});

var tokenSelector = function tokenSelector(enableMapSelectors) {
  return function (state) {
    return enableMapSelectors ? state.get("firebaseTokens").currentToken : state.firebaseTokens.currentToken;
  };
};

var _sagasToThunksMapping;

var sagasToThunksMapping = (_sagasToThunksMapping = {}, _sagasToThunksMapping[notificationsSlice.actions.indexRequest.type] = indexNotifications, _sagasToThunksMapping[notificationsSlice.actions.markAsReadRequest.type] = markAsRead, _sagasToThunksMapping[notificationsSlice.actions.resetByLocale.type] = resetNotificationsByLocale, _sagasToThunksMapping[firebaseTokensSlice.actions.setTokenRequest.type] = setFirebaseToken, _sagasToThunksMapping[firebaseTokensSlice.actions.deleteTokenRequest.type] = deleteFirebaseToken, _sagasToThunksMapping);

var useCustomDispatch = function useCustomDispatch() {
  var _configs$getConfigs = configs.getConfigs(),
      enableThunks = _configs$getConfigs.enableThunks;

  var reduxDispatch = reactRedux.useDispatch();
  var dispatch = React.useCallback(function (action, payload) {
    if (!enableThunks) return reduxDispatch(action(payload));
    var selectedAction = sagasToThunksMapping[action.type] || action;
    reduxDispatch(selectedAction(payload));
  }, [enableThunks, reduxDispatch]);
  return dispatch;
};

var useInfiniteScroll = function useInfiniteScroll(_ref, loading, liveNotificationCount, perPage) {
  var current = _ref.current;

  var _useState = React.useState({
    page: 1,
    pageHeight: 1
  }),
      scrollPage = _useState[0],
      setScrollPage = _useState[1];

  var page = scrollPage.page,
      pageHeight = scrollPage.pageHeight;

  var onScroll = function onScroll() {
    var clientHeight = current.clientHeight,
        scrollTop = current.scrollTop,
        scrollHeight = current.scrollHeight;
    if (scrollTop === 0) return;
    var bottom = scrollHeight - clientHeight;

    if (Math.ceil(scrollTop) >= bottom && !loading && scrollHeight > pageHeight) {
      setScrollPage({
        page: page + 1 + Math.floor(liveNotificationCount / perPage),
        pageHeight: scrollHeight
      });
    }
  };

  var resetPage = React.useCallback(function () {
    setScrollPage({
      page: 1,
      pageHeight: 1
    });
  }, []);
  return {
    page: page,
    onScroll: onScroll,
    resetPage: resetPage
  };
};

var usePrevious = function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};

var useDidMount = function useDidMount() {
  var didMount = React.useRef(false);
  React.useEffect(function () {
    didMount.current = true;
  }, []);
  return didMount.current;
};

var useFirebase = function useFirebase(enableFirebase, onReceiveNotification, enableMapSelector, language) {
  if (enableFirebase === void 0) {
    enableFirebase = true;
  }

  var token = reactRedux.useSelector(tokenSelector(enableMapSelector));
  var previousListener = React.useRef(null);
  React.useEffect(function () {
    if (!(enableFirebase && token)) return;

    try {
      var messaging$1 = messaging.getMessaging();
      if (previousListener.current) previousListener.current();
      previousListener.current = messaging.onMessage(messaging$1, function (payload) {
        var notification = payload.notification,
            data = payload.data;
        var notificationObject = {
          title: notification.title,
          body: notification.body,
          created_at: new Date().toISOString(),
          is_read: false,
          data_object: safeJSONParse(data["gcm.notification.data_object"]),
          image_url: data["gcm.notification.image_url"],
          reference_uuid: data["gcm.notification.reference_uuid"],
          translations: safeJSONParse(data["gcm.notification.translations"]),
          event_key: data["gcm.notification.event_key"]
        };
        onReceiveNotification(notificationObject);
      });
    } catch (e) {
      console.warn("Push notifications are unsupported for this browser");
    }
  }, [token, enableFirebase, onReceiveNotification, language]);
};

var perPage = 10;

var useNotifications = function useNotifications(_ref) {
  var isInitiallyClicked = _ref.isInitiallyClicked,
      enableBulkMarkAsRead = _ref.enableBulkMarkAsRead,
      enableFirebase = _ref.enableFirebase,
      externalOnReceiveNotification = _ref.onReceiveNotification,
      enableMapSelectors = _ref.enableMapSelectors;
  var storedEntity = reactRedux.useSelector(notificationsSelector(enableMapSelectors));
  var dispatch = useCustomDispatch();
  var didMount = useDidMount();
  var dropDownRef = React.useRef(null);

  var _useState = React.useState(null),
      unreadCount = _useState[0],
      setUnreadCount = _useState[1];

  var _useState2 = React.useState(0),
      currentliveNotificationCount = _useState2[0],
      setCurrentLiveNotificationCount = _useState2[1];

  var _useTranslation = reactI18next.useTranslation("notificationsPackage"),
      i18n = _useTranslation.i18n;

  var language = i18n.language;
  var currentData = storedEntity.currentData,
      meta = storedEntity.meta;

  var _useInfiniteScroll = useInfiniteScroll(dropDownRef, storedEntity.loading, currentliveNotificationCount, perPage),
      page = _useInfiniteScroll.page,
      onScroll = _useInfiniteScroll.onScroll,
      resetPage = _useInfiniteScroll.resetPage;

  var previousPage = usePrevious(page);
  var onReceiveNotification = React.useCallback(function (notification) {
    var _notification$transla, _notification$transla2, _notification$transla3, _notification$transla4;

    notification.title = ((_notification$transla = notification.translations) === null || _notification$transla === void 0 ? void 0 : (_notification$transla2 = _notification$transla[language]) === null || _notification$transla2 === void 0 ? void 0 : _notification$transla2.title) || notification.title;
    notification.body = ((_notification$transla3 = notification.translations) === null || _notification$transla3 === void 0 ? void 0 : (_notification$transla4 = _notification$transla3[language]) === null || _notification$transla4 === void 0 ? void 0 : _notification$transla4.body) || notification.body;
    setUnreadCount(function (count) {
      return count + 1;
    });
    setCurrentLiveNotificationCount(function (count) {
      return count + 1;
    });
    dispatch(notificationsSlice.actions.addOne, notification);
    externalOnReceiveNotification === null || externalOnReceiveNotification === void 0 ? void 0 : externalOnReceiveNotification(notification);
  }, [dispatch, externalOnReceiveNotification, language]);
  var markAsRead = React.useCallback(function (_ref2) {
    var notifications = _ref2.notifications,
        ids = _ref2.ids;

    if (ids) {
      setUnreadCount(0);
      dispatch(notificationsSlice.actions.markAsReadRequest, {
        notificationsIds: ids,
        markAllAsRead: true
      });
      return;
    }

    var _notifications$reduce = notifications.reduce(function (accum, notification) {
      accum.notificationsIds.push(notification.reference_uuid);
      if (!notification.is_read) accum.unreadCount += 1;
      return accum;
    }, {
      notificationsIds: [],
      unreadCount: 0
    }),
        notificationsIds = _notifications$reduce.notificationsIds,
        unreadCount = _notifications$reduce.unreadCount;

    if (unreadCount > 0) {
      dispatch(notificationsSlice.actions.markAsReadRequest, {
        notificationsIds: notificationsIds
      });
      setUnreadCount(function (count) {
        return count - unreadCount;
      });
    }
  }, [dispatch]);
  var onWindowFocus = React.useCallback(function () {
    dispatch(notificationsSlice.actions.indexRequest, {
      page: 1,
      per_page: perPage,
      storedEntity: storedEntity,
      locale: language
    });
  }, [language, perPage, storedEntity, dispatch]);
  useFirebase(enableFirebase, onReceiveNotification, enableMapSelectors);
  React.useEffect(function () {
    if (meta.unread_count !== undefined && meta.current_page === 1) setUnreadCount(meta.unread_count);
  }, [meta]);
  React.useEffect(function () {
    if (page <= previousPage) return;

    if (!(storedEntity.meta.next_page === null)) {
      dispatch(notificationsSlice.actions.indexRequest, {
        page: page,
        per_page: perPage,
        storedEntity: storedEntity,
        locale: language
      });
      setCurrentLiveNotificationCount(0);
    }
  }, [page, dispatch]);
  React.useEffect(function () {
    if (didMount) {
      resetPage();
      dispatch(notificationsSlice.actions.resetByLocale, {
        page: 1,
        per_page: perPage,
        storedEntity: storedEntity,
        locale: language
      });
      setCurrentLiveNotificationCount(0);
    }
  }, [language, dispatch]);
  React.useEffect(function () {
    if (currentData.length > 0 && isInitiallyClicked && enableBulkMarkAsRead) markAsRead({
      notifications: currentData
    });
  }, [currentData, isInitiallyClicked, enableBulkMarkAsRead, markAsRead]);
  React.useEffect(function () {
    window.onfocus = onWindowFocus;
    return function () {
      return window.onfocus = null;
    };
  }, [onWindowFocus]);
  React.useEffect(function () {
    return function () {
      dispatch(notificationsSlice.actions.reset);
    };
  }, [dispatch]);
  return {
    storedEntity: storedEntity,
    page: page,
    onScroll: onScroll,
    dropDownRef: dropDownRef,
    markAsRead: markAsRead,
    unreadCount: unreadCount
  };
};

var useDropDown = function useDropDown() {
  var _useState = React.useState(false),
      isInitiallyClicked = _useState[0],
      setIsInitiallyClicked = _useState[1];

  var _useState2 = React.useState(false),
      isDropDownVisible = _useState2[0],
      setIsDropDownVisible = _useState2[1];

  var openDropDown = function openDropDown() {
    if (!isInitiallyClicked) setIsInitiallyClicked(true);
    setIsDropDownVisible(!isDropDownVisible);
  };

  var closeDropDown = React.useCallback(function () {
    setIsDropDownVisible(false);
  }, []);
  return {
    isInitiallyClicked: isInitiallyClicked,
    isDropDownVisible: isDropDownVisible,
    openDropDown: openDropDown,
    closeDropDown: closeDropDown
  };
};

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2;

var NotificationItemContainer = styled__default.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  padding: 10px 0px;\n  border-bottom: 1.5px solid #e0e0e0;\n  ", "\n"])), function (props) {
  return props.displayAsLink && "&:hover {\n  border-radius: 5px;\n  background-color: rgba(52, 152, 219, 0.2);\n  transition: all 0.3s ease;\n}";
});
var NotificationContentContainer = styled__default.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: baseline;\n  time {\n    color: ", ";\n  }\n  h3 {\n    margin-bottom: 0.1em;\n  }\n  @media (max-width: ", ") {\n    flex-direction: column;\n    justify-content: center;\n  }\n"])), function (props) {
  return props.theme.notificationColors.date;
}, function (props) {
  return props.theme.breakpoints.xxs || props.theme.breakpoints.$xxs;
});
var NotificationTextContainer = styled__default.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n  margin: 0px 10px;\n  width: 100%;\n  overflow: hidden;\n  white-space: wrap;\n  text-overflow: ellipsis;\n"])));
var UnreadContainer = styled__default.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  @media (max-width: ", ") {\n    width: 80%;\n  }\n  ", "\n  animation: ", " 300ms ease-in-out forwards;\n  animation-delay: ", "s;\n"])), function (props) {
  return props.theme.breakpoints.xxs || props.theme.breakpoints.$xxs;
}, function (props) {
  return props.isInitialRead && "display:none;";
}, function (props) {
  return props.isRead ? opacityOut : "none";
}, function (props) {
  return props.isLink ? 0 : props.markAsReadTimer;
});
var UnreadCircle = styled__default.span(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0px 25px;\n  width: 0.8em;\n  height: 0.8em;\n  background-color: ", ";\n"])), function (props) {
  return props.theme.notificationColors.unreadNotification;
});
var _default = {
  __proto__: null,
  NotificationContentContainer: NotificationContentContainer,
  NotificationItemContainer: NotificationItemContainer,
  NotificationTextContainer: NotificationTextContainer,
  UnreadCircle: UnreadCircle,
  UnreadContainer: UnreadContainer
};

var _templateObject$3, _templateObject2$3, _templateObject3$3, _templateObject4$3, _templateObject5$3;

var NotificationItemContainer$1 = styled__default.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  padding: 18px 0px;\n  margin-bottom: 1em;\n  box-shadow: ", ";\n  border-radius: 10px;\n  ", "\n"])), function (props) {
  return props.isRead ? "0 3px 0px -10px #0000001f, 0 3px 8px #00000014, 0 9px 50px -25px #0000000d" : "0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d";
}, function (props) {
  return props.displayAsLink && "&:hover {\n  background-color: rgba(52, 152, 219, 0.2);\n  transition: all 0.3s ease;\n}";
});
var NotificationContentContainer$1 = styled__default.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: baseline;\n  time {\n    color: ", ";\n  }\n  h3 {\n    font-weight: 900;\n    margin-bottom: 0.1em;\n  }\n  @media (max-width: ", ") {\n    flex-direction: column;\n    justify-content: center;\n  }\n"])), function (props) {
  return props.theme.notificationColors.date;
}, function (props) {
  return props.theme.breakpoints.xxs || props.theme.breakpoints.$xxs;
});
var NotificationTextContainer$1 = styled__default.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  margin: 0px 10px;\n  width: 100%;\n  overflow: hidden;\n  white-space: wrap;\n  text-overflow: ellipsis;\n"])));
var UnreadContainer$1 = styled__default.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  @media (max-width: ", ") {\n    width: 80%;\n  }\n  //", "\n  animation: ", " 300ms ease-in-out forwards;\n  animation-delay: ", "s;\n"])), function (props) {
  return props.theme.breakpoints.xxs || props.theme.breakpoints.$xxs;
}, function (props) {
  return props.isInitialRead && "display:none;";
}, function (props) {
  return props.isRead ? opacityOut : "none";
}, function (props) {
  return props.isLink ? 0 : props.markAsReadTimer;
});
var UnreadCircle$1 = styled__default.span(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n  border-radius: 50%;\n  display: inline-block;\n  margin: 0px 10px;\n  width: 0.8em;\n  height: 0.8em;\n  ", ";\n"])), function (props) {
  return !props.isRead && "background-color: " + props.theme.notificationColors.unreadNotification;
});
var hamza = {
  __proto__: null,
  NotificationItemContainer: NotificationItemContainer$1,
  NotificationContentContainer: NotificationContentContainer$1,
  NotificationTextContainer: NotificationTextContainer$1,
  UnreadCircle: UnreadCircle$1,
  UnreadContainer: UnreadContainer$1
};
var components = {
  __proto__: null,
  defaultComponents: _default,
  hamza: hamza
};

var NotificationItem = function NotificationItem(_ref) {
  var notification = _ref.notification,
      displayAsLink = _ref.displayAsLink,
      displayImages = _ref.displayImages,
      markAsRead = _ref.markAsRead,
      itemStyle = _ref.itemStyle,
      markAsReadTimer = _ref.markAsReadTimer,
      closeDropDown = _ref.closeDropDown,
      messageLayout = _ref.messageLayout;

  var _useTranslation = reactI18next.useTranslation("notifications"),
      i18n = _useTranslation.i18n;

  var onClick = function onClick() {
    markAsRead === null || markAsRead === void 0 ? void 0 : markAsRead({
      notifications: [notification]
    });
    closeDropDown();
  };

  var image_url = notification.image_url,
      title = notification.title,
      body = notification.body,
      created_at = notification.created_at,
      is_read = notification.is_read;
  var isInitialRead = React.useRef(is_read);
  var link = displayAsLink === null || displayAsLink === void 0 ? void 0 : displayAsLink(notification);

  var _configs$getConfigs = configs.getConfigs(),
      theme = _configs$getConfigs.theme,
      defaultImageUrl = _configs$getConfigs.defaultImageUrl;

  var _components = components[theme.notificationLayout.itemTheme || "defaultComponents"],
      NotificationItemContainer = _components.NotificationItemContainer,
      NotificationContentContainer = _components.NotificationContentContainer,
      NotificationTextContainer = _components.NotificationTextContainer,
      UnreadCircle = _components.UnreadCircle,
      UnreadContainer = _components.UnreadContainer;
  var unReadComponent = /*#__PURE__*/React__default.createElement(UnreadContainer, {
    isLink: link,
    markAsReadTimer: markAsReadTimer,
    isInitialRead: isInitialRead.current,
    isRead: is_read
  }, /*#__PURE__*/React__default.createElement(UnreadCircle, {
    isRead: is_read,
    className: "unread-circle"
  }));
  console.log(i18n.language, "language");

  var renderMessage = function renderMessage() {
    switch (messageLayout) {
      case "title-message-date":
        return /*#__PURE__*/React__default.createElement(NotificationTextContainer, null, /*#__PURE__*/React__default.createElement(NotificationContentContainer, {
          className: "notification-content-container"
        }, /*#__PURE__*/React__default.createElement("h3", null, title), /*#__PURE__*/React__default.createElement("div", {
          className: "body"
        }, body)), /*#__PURE__*/React__default.createElement(NotificationContentContainer, {
          className: "notification-content-container"
        }, /*#__PURE__*/React__default.createElement(ReactTimeAgo, {
          date: Date.parse(created_at),
          locale: i18n.language
        }), displayImages && unReadComponent));

      default:
        return /*#__PURE__*/React__default.createElement(NotificationTextContainer, null, /*#__PURE__*/React__default.createElement(NotificationContentContainer, {
          className: "notification-content-container"
        }, /*#__PURE__*/React__default.createElement("h3", null, title), /*#__PURE__*/React__default.createElement(ReactTimeAgo, {
          date: Date.parse(created_at),
          locale: i18n.language
        })), /*#__PURE__*/React__default.createElement(NotificationContentContainer, {
          className: "notification-content-container"
        }, /*#__PURE__*/React__default.createElement("div", null, body), displayImages && unReadComponent));
    }
  };

  var item = /*#__PURE__*/React__default.createElement(NotificationItemContainer, {
    isRead: is_read,
    style: itemStyle,
    displayAsLink: displayAsLink,
    className: "notification-item-container"
  }, displayImages ? /*#__PURE__*/React__default.createElement(Image, {
    src: image_url || defaultImageUrl,
    alt: title
  }) : unReadComponent, renderMessage());
  return link ? /*#__PURE__*/React__default.createElement(reactRouterDom.Link, {
    onClick: onClick,
    to: link
  }, item) : item;
};

var NotificationItem$1 = React.memo(NotificationItem);

var _templateObject$4, _templateObject2$4, _templateObject3$4, _templateObject4$4, _templateObject5$4, _templateObject6$1, _templateObject7$1, _templateObject8$1;

var LoadingOverLay = styled__default.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  left: 0;\n  top: 0%;\n  position: relative;\n  ", "\n"])), function (props) {
  return props.theme.notificationLayout.showEmptyIcon && props.noDataFound && "height:50%;display:flex;align-items:center;";
});
var LoadingOverLayInner = styled__default.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose([""])));
var LoadingContent = styled__default.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  text-align: center;\n"])));
var spin = styled.keyframes(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var Loadable = styled__default.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n  border-width: 2px;\n  border-color: #40a9ff;\n  border-top-color: #fff;\n  animation: ", " 1s infinite linear;\n  border-radius: 100%;\n  border-style: solid;\n"])), function (props) {
  return props.width ? props.width + "px" : "50px";
}, function (props) {
  return props.width ? props.width + "px" : "50px";
}, spin);
var NoDataFoundContainer = styled__default.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var NoDataFoundMessage = styled__default.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), function (props) {
  return props.theme.notificationColors.noDataMessage || "#000";
});
var EmptyImage = styled__default.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  svg {\n    color: ", ";\n    font-size: 10em;\n  }\n  svg:hover {\n    color: ", ";\n    cursor: auto;\n  }\n"])), function (props) {
  return props.theme.notificationLayout.showEmptyIcon ? "block" : "none";
}, function (props) {
  return props.theme.notificationColors.noDataMessage || "#000";
}, function (props) {
  return props.theme.notificationColors.noDataMessage || "#000";
});

var Loader = function Loader(_ref) {
  var noDataFound = _ref.noDataFound;

  var _useTranslation = reactI18next.useTranslation("notificationsPackage"),
      t = _useTranslation.t;

  return /*#__PURE__*/React__default.createElement(LoadingOverLay, {
    noDataFound: noDataFound
  }, /*#__PURE__*/React__default.createElement(LoadingOverLayInner, null, /*#__PURE__*/React__default.createElement(LoadingContent, null, noDataFound ? /*#__PURE__*/React__default.createElement(NoDataFoundContainer, null, /*#__PURE__*/React__default.createElement(EmptyImage, null, /*#__PURE__*/React__default.createElement(bi.BiBellMinus, null)), /*#__PURE__*/React__default.createElement(NoDataFoundMessage, {
    className: "no-data-found-message"
  }, t("noDataFoundMessage"), " ")) : /*#__PURE__*/React__default.createElement(Loadable, null))));
};

var SettingsDropDown = function SettingsDropDown(_ref) {
  var ids = _ref.ids,
      markAsRead = _ref.markAsRead;

  var _useDropDown = useDropDown(),
      isInitiallyClicked = _useDropDown.isInitiallyClicked,
      isDropDownVisible = _useDropDown.isDropDownVisible,
      openDropDown = _useDropDown.openDropDown,
      closeDropDown = _useDropDown.closeDropDown;

  var _useTranslation = reactI18next.useTranslation("notificationsPackage"),
      t = _useTranslation.t;

  var markAllAsRead = function markAllAsRead() {
    markAsRead({
      ids: ids
    });
    closeDropDown();
  };

  return /*#__PURE__*/React__default.createElement(NotificationSettings, {
    className: "notification-settings"
  }, /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: closeDropDown
  }, /*#__PURE__*/React__default.createElement(fi.FiMoreHorizontal, {
    onClick: openDropDown
  })), /*#__PURE__*/React__default.createElement(SettingsDropDownContainer, {
    isInitiallyClicked: isInitiallyClicked,
    isDropDownVisible: isDropDownVisible,
    className: "settings-drop-down-container"
  }, /*#__PURE__*/React__default.createElement(CheckMarkContainer, null, /*#__PURE__*/React__default.createElement(fc.FcCheckmark, null)), /*#__PURE__*/React__default.createElement(MarkAllAsRead, {
    onClick: markAllAsRead
  }, t("markAllAsRead"))));
};

var _excluded = ["data", "markAsRead", "noDataFound", "initialLoading", "customItemComponent", "enableMapSelectors", "closeDropDown"];

var NotificationsList = function NotificationsList(_ref) {
  var data = _ref.data,
      markAsRead = _ref.markAsRead,
      noDataFound = _ref.noDataFound,
      initialLoading = _ref.initialLoading,
      customItemComponent = _ref.customItemComponent,
      closeDropDown = _ref.closeDropDown,
      itemProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _configs$getConfigs = configs.getConfigs(),
      theme = _configs$getConfigs.theme;

  var _useTranslation = reactI18next.useTranslation("notificationsPackage"),
      t = _useTranslation.t;

  var CustomItemComponent = customItemComponent;
  var Item = CustomItemComponent || NotificationItem$1;

  var renderNotificationItems = function renderNotificationItems() {
    return data.ids.map(function (id) {
      return /*#__PURE__*/React__default.createElement(Item, _extends({
        displayImages: theme.notificationLayout.displayImages,
        key: id,
        id: id,
        notification: data.entities[id],
        markAsRead: markAsRead,
        closeDropDown: closeDropDown
      }, itemProps));
    });
  };

  var renderNotifications = function renderNotifications() {
    if (initialLoading || noDataFound) return /*#__PURE__*/React__default.createElement(Loader, {
      noDataFound: noDataFound
    });
    return renderNotificationItems();
  };

  return /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(NotificationTitleContainer, null, /*#__PURE__*/React__default.createElement("h2", null, t("title")), /*#__PURE__*/React__default.createElement(SettingsDropDown, {
    ids: data.ids,
    markAsRead: markAsRead
  })), renderNotifications());
};

var NotificationsList$1 = React.memo(NotificationsList);
var title = "Notifications";
var noDataFoundMessage = "You have no notifications yet";
var noMoreDataMessage = "You have no more notifications";
var markAllAsRead = "Mark all as read";
var en = {
  title: title,
  noDataFoundMessage: noDataFoundMessage,
  noMoreDataMessage: noMoreDataMessage,
  markAllAsRead: markAllAsRead
};
var title$1 = "الإشعارات";
var noMoreDataMessage$1 = "ليس لديك المزيد من الإشعارات";
var noDataFoundMessage$1 = "ليس لديك أي إشعارات حتى الآن";
var markAllAsRead$1 = "علامة كمقروء للكل";
var ar = {
  title: title$1,
  noMoreDataMessage: noMoreDataMessage$1,
  noDataFoundMessage: noDataFoundMessage$1,
  markAllAsRead: markAllAsRead$1
};
TimeAgo.addDefaultLocale(enTimeAgo);
TimeAgo.addLocale(arTimeAgo);

var NotificationCenter = function NotificationCenter(_ref) {
  var align = _ref.align,
      listStyle = _ref.listStyle,
      itemStyle = _ref.itemStyle,
      customListComponent = _ref.customListComponent,
      customItemComponent = _ref.customItemComponent,
      customIconComponent = _ref.customIconComponent,
      displayAsLink = _ref.displayAsLink,
      _ref$markAsReadTimer = _ref.markAsReadTimer,
      markAsReadTimer = _ref$markAsReadTimer === void 0 ? 3 : _ref$markAsReadTimer,
      onReceiveNotification = _ref.onReceiveNotification,
      messageLayout = _ref.messageLayout;

  var _configs$getConfigs = configs.getConfigs(),
      theme = _configs$getConfigs.theme,
      enableFirebase = _configs$getConfigs.enableFirebase,
      enableMapSelectors = _configs$getConfigs.enableMapSelectors;

  var _useDropDown = useDropDown(),
      isInitiallyClicked = _useDropDown.isInitiallyClicked,
      isDropDownVisible = _useDropDown.isDropDownVisible,
      openDropDown = _useDropDown.openDropDown,
      closeDropDown = _useDropDown.closeDropDown;

  var enableBulkMarkAsRead = !displayAsLink;

  var _useNotifications = useNotifications({
    isInitiallyClicked: isInitiallyClicked,
    enableBulkMarkAsRead: enableBulkMarkAsRead,
    enableFirebase: enableFirebase,
    onReceiveNotification: onReceiveNotification,
    enableMapSelectors: enableMapSelectors
  }),
      storedEntity = _useNotifications.storedEntity,
      onScroll = _useNotifications.onScroll,
      dropDownRef = _useNotifications.dropDownRef,
      markAsRead = _useNotifications.markAsRead,
      unreadCount = _useNotifications.unreadCount;

  var ids = storedEntity.ids,
      entities = storedEntity.entities,
      loading = storedEntity.loading,
      meta = storedEntity.meta;

  var _useTranslation = reactI18next.useTranslation("notificationsPackage"),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  React.useEffect(function () {
    i18n.addResources("en", "notificationsPackage", en);
    i18n.addResources("ar", "notificationsPackage", ar);
  }, []);
  var isEmptyData = ids.length === 0;
  var noDataFound = !loading && isEmptyData;
  var initialLoading = loading && isEmptyData;

  var renderUnreadCount = function renderUnreadCount() {
    return /*#__PURE__*/React__default.createElement(UnreadCount, {
      isVisible: unreadCount > 0,
      className: "unread-count"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "unread-number"
    }, unreadCount));
  };

  var renderMeta = function renderMeta() {
    if (meta.next_page && !loading || isEmptyData) return null;
    return /*#__PURE__*/React__default.createElement(Meta, {
      className: "meta"
    }, loading ? /*#__PURE__*/React__default.createElement(Loadable, {
      width: 25
    }) : t("noMoreDataMessage"));
  };

  var renderForceScroll = function renderForceScroll() {
    var current = dropDownRef.current;
    var isScrollBarVisible = current && current.scrollHeight > current.clientHeight;
    if (!isScrollBarVisible && meta.current_page === 1 && meta.next_page) return /*#__PURE__*/React__default.createElement(ForceScroll, null);
  };

  var renderNotificationsList = function renderNotificationsList() {
    var props = {
      noDataFound: noDataFound,
      meta: meta,
      data: {
        ids: ids,
        entities: entities
      },
      markAsRead: markAsRead,
      displayAsLink: displayAsLink,
      initialLoading: initialLoading,
      itemStyle: itemStyle,
      customItemComponent: customItemComponent,
      markAsReadTimer: markAsReadTimer,
      closeDropDown: closeDropDown,
      messageLayout: messageLayout
    };
    var CustomListComponent = customListComponent;
    return customListComponent ? /*#__PURE__*/React__default.createElement(CustomListComponent, props) : /*#__PURE__*/React__default.createElement(NotificationsList$1, props);
  };

  var renderIcon = function renderIcon() {
    var CustomIconComponent = customIconComponent;
    var DefaultIcon = theme.notificationLayout.isIconOutlined ? /*#__PURE__*/React__default.createElement(io.IoIosNotificationsOutline, null) : /*#__PURE__*/React__default.createElement(io.IoIosNotifications, null);
    return CustomIconComponent ? /*#__PURE__*/React__default.createElement(CustomIconComponent, null) : DefaultIcon;
  };

  var getAlignment = function getAlignment() {
    var dir = i18n.dir(i18n.language);
    if (align) return align === "right" ? "right" : "left";
    return dir === "rtl" ? "right" : "left";
  };

  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(NotificationCenterContainer, null, /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: closeDropDown
  }, /*#__PURE__*/React__default.createElement(NotificationIcon, {
    isInitiallyClicked: isInitiallyClicked,
    isDropDownVisible: isDropDownVisible,
    onClick: openDropDown,
    className: "notification-icon"
  }, renderIcon(), renderUnreadCount()), /*#__PURE__*/React__default.createElement(DropDownContainer, {
    noDataFound: noDataFound,
    onScroll: onScroll,
    ref: dropDownRef,
    isDropDownVisible: isDropDownVisible,
    isInitiallyClicked: isInitiallyClicked,
    style: listStyle,
    align: getAlignment(),
    className: "drop-down-container"
  }, renderNotificationsList(), renderMeta(), renderForceScroll()))));
};

var index = React.memo(NotificationCenter);

var useFirebasePermissions = function useFirebasePermissions() {
  var dispatch = useCustomDispatch();

  var _configs$getConfigs = configs.getConfigs(),
      firebaseConfig = _configs$getConfigs.firebaseConfig;

  var getFireBaseToken = React.useCallback(function () {
    var messaging$1 = messaging.getMessaging();
    messaging.getToken(messaging$1, {
      vapidKey: firebaseConfig.vapidKey
    }).then(function (token) {
      if (token) {
        FingerprintJS.load().then(function (fingerPrint) {
          return fingerPrint.get().then(function (result) {
            dispatch(firebaseTokensSlice.actions.setTokenRequest, {
              device_id: result.visitorId,
              token: token
            });
          });
        });
      }
    }).catch(function (err) {
      console.warn("An error occurred while retrieving token. ", err);
    });
  }, [firebaseConfig, dispatch]);
  var initializeFireBase = React.useCallback(function () {
    try {
      return app.initializeApp(firebaseConfig);
    } catch (error) {
      console.warn("Push notifications are unsupported for this browser");
    }
  }, [firebaseConfig]);
  var setFirebaseToken = React.useCallback(function () {
    if (!firebaseConfig) return console.warn("You have attempted to use firebase without providing the required configuration.");
    initializeFireBase();
    getFireBaseToken();
  }, [firebaseConfig, initializeFireBase, getFireBaseToken]);
  var deleteDeviceToken = React.useCallback(function (authHeaders) {
    FingerprintJS.load().then(function (fingerPrint) {
      return fingerPrint.get().then(function (result) {
        dispatch(firebaseTokensSlice.actions.deleteTokenRequest, {
          device_id: result.visitorId,
          headers: authHeaders
        });
      });
    });
  }, [dispatch]);
  return {
    setFirebaseToken: setFirebaseToken,
    deleteDeviceToken: deleteDeviceToken
  };
};

exports.TimeAgo = TimeAgo;
exports.ReactTimeAgo = ReactTimeAgo;
exports.NotificationCenter = index;
exports.firebaseTokensSlice = firebaseTokensSlice;
exports.notificationsConfigs = configs;
exports.notificationsGeneralSelectors = notificationsGeneralSelectors;
exports.notificationsSelector = notificationsSelector;
exports.notificationsSlice = notificationsSlice;
exports.sagas = sagas;
exports.useFirebasePermissions = useFirebasePermissions;
exports.useInfiniteScroll = useInfiniteScroll;
exports.useNotifications = useNotifications;